import React, { FC, useState } from 'react';
import DatePicker from 'react-multi-date-picker';
import Button from '../../../../../../components/Button';
import CalendarInput from '../../../../../../components/CalendarInput';
import Select from '../../../../../../components/Select';
import { months, weekDays } from '../../../../../../const/calendar';
import { serviceOptions, statusPayOrderOptions } from '../../../../consts';
import styles from '../../styles/index.module.scss';
import 'react-responsive-modal/styles.css';

interface IBillsSortMenu {
  filterParams?: Record<string, any>
  loadData?: any,
  isDisabled?: boolean,
}

const PayOrderSortMenu: FC<IBillsSortMenu> = ({ filterParams, loadData, isDisabled }) => {
  const [date, setDate] = useState<any>(new Date());

  const handleAddDate = (date: any) => {
    if (date[0]) {
      loadData(1, {
        ...filterParams,
        start_date: date[0].format('YYYY-MM-DD'),
        end_date: date.length > 1 ? date[1].format('YYYY-MM-DD') : date[0].format('YYYY-MM-DD')
      });
      setDate(date);
    }
  };

  const handleRemoveDate = () => {
    setDate('');
    loadData(1, {
      ...filterParams,
      start_date: null,
      end_date: null
    });
  };
  const update = () => {
    loadData(1, {
      ...filterParams,
    })
  }

  return (
    <div className={styles['wrapper']}>
      <div className={styles['orders--group']}>
        <div className={styles['menu']}>
          <Select
            className={styles['menu-select']}
            isDisabled={isDisabled}
            options={statusPayOrderOptions}
            defaultValue={statusPayOrderOptions[4]}
            onChange={((option: any) => loadData(1,
              { ...filterParams, ...(Number(option.value) !== 4 ? { status: option.value } : { status: null }) }
            )
            )}
          />
          <Select
            className={styles['menu-select']}
            isDisabled={isDisabled}
            options={serviceOptions}
            defaultValue={serviceOptions[1]}
            onChange={((option: any) => loadData(1,
              { ...filterParams, ...(Number(option.value) !== 10 ? { service_type: option.value } : { service_type: null }) }
            )
            )}
          />
        </div>
        <div className={styles['onloading']}>

          <div className={styles['onloading--date']}>
            <DatePicker
              disabled={isDisabled}
              onChange={handleAddDate}
              weekDays={weekDays}
              months={months}
              render={<CalendarInput
                clear={handleRemoveDate}
                type='sm_xl'
                value={date}
                disabled={isDisabled}
              />
              }
              weekStartDayIndex={1}
              range
              value={date}
            />
          </div>
          <Button className={styles['onloading--btn']} onClick={update}>
            Обновить
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PayOrderSortMenu;
